import cookies from "js-cookie";
import getEnvironmentName from "../getEnvironmentName";
import getCookieName from "../getCookieName";
import { DEFAULT_COOKIE_OPTIONS } from "../../consts";

const env = getEnvironmentName();
const keyName = getCookieName({ name: "companyId", env });

export function getCompanyIdFromCookies() {
  return cookies.get(keyName);
}

export function setCompanyIdToCookies(companyId) {
  return cookies.set(keyName, companyId, DEFAULT_COOKIE_OPTIONS);
}
